import { NgModule } from '@angular/core';
import { MergeQueueGuardDirective } from './merge-queue-guard.directive';

@NgModule({
  declarations: [MergeQueueGuardDirective],
  exports: [MergeQueueGuardDirective],
})
export class MergeQueueGuardDirectiveModule {}
